
import { defineComponent, ref, PropType } from 'vue'
import FormFieldPackages from '@/components/_shared/form-fields/packages.vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import { useFreeSubscriptionsModule } from '@/modules/free-subscriptions'

export default defineComponent({
    name: 'free-forms-edit-packages-dialog',
    components: { FormFieldPackages },
    props: {
        packages: {
            type: Array as PropType<string[]>,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        updateCallback: {
            type: Function as PropType<(t: string[]) => void>,
            required: true
        }
    },
    emits: [...useDialogPluginComponent.emits],
    setup (props) {
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
        const { submitForm, createOnSuccess } = useFormModule()
        const { updateFreeSubscriptionPackages } = useFreeSubscriptionsModule()

        const form = ref<QForm>()
        const packagesModel = ref(props.packages)

        const sendRequest = async () => {
            await updateFreeSubscriptionPackages(
                props.id, {
                    subscriptionId: props.id,
                    packages: packagesModel.value
                })
        }

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Free subscriptions packages changed')
        )
            .then(() => {
                onDialogOK()
                props.updateCallback(packagesModel.value)
            })

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            packagesModel,
            onSubmit,
            form
        }
    }
})
